import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useUserContext } from '../context/UserContext';

export function AuthCallbackPage() {
  const { isLoading: authLoading, isAuthenticated } = useAuth0();
  const { me, loading: userLoading } = useUserContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (authLoading || !isAuthenticated || userLoading) return;
    if (!me) {
      navigate('/account', { replace: true });
      return;
    }
    const hasSubscription =
      me.entitlements.marketIds.length > 0 ||
      me.entitlements.neighborhoodIds.length > 0;
    navigate(hasSubscription ? '/dashboard' : '/account', { replace: true });
  }, [authLoading, isAuthenticated, userLoading, me, navigate]);

  return <div style={{ padding: '2rem' }}>Signing you in...</div>;
}
